import type { SportCategory, Topic } from '../types'

export const categories: SportCategory[] = [
  'all',
  'workout',
  'running',
  'cycling',
  'swimming',
  'crossfit',
  'strength',
  'nutrition',
  'mindfulness',
  'lifestyle',
]

export const topics: Topic[] = [
  {
    id: 'sleep-first',
    title: { 'pt-BR': 'Sono como base do treino', 'en-US': 'Sleep as training base' },
    subtitle: {
      'pt-BR': 'Como a comunidade está protegendo as noites antes do treino forte.',
      'en-US': 'How the community protects the nights before hard sessions.',
    },
    posts: 312,
    category: 'lifestyle',
  },
  {
    id: 'first-10k',
    title: { 'pt-BR': 'Do zero aos 10 km', 'en-US': 'From zero to 10 km' },
    subtitle: {
      'pt-BR': 'Relatos de quem começou a correr nos últimos três meses.',
      'en-US': 'Stories from people who started running in the last three months.',
    },
    posts: 486,
    category: 'running',
  },
  {
    id: 'meal-prep',
    title: { 'pt-BR': 'Preparo da semana', 'en-US': 'Weekly meal prep' },
    subtitle: {
      'pt-BR': 'Rotinas simples de alimentação que sobrevivem a semanas cheias.',
      'en-US': 'Simple food routines that survive busy weeks.',
    },
    posts: 204,
    category: 'nutrition',
  },
  {
    id: 'five-minutes',
    title: { 'pt-BR': 'Cinco minutos de mente', 'en-US': 'Five minutes of mind' },
    subtitle: {
      'pt-BR': 'Práticas curtas de respiração para dias sem tempo.',
      'en-US': 'Short breathing practices for days with no time.',
    },
    posts: 167,
    category: 'mindfulness',
  },
  {
    id: 'load-progression',
    title: { 'pt-BR': 'Progressão de carga sem dor', 'en-US': 'Pain-free load progression' },
    subtitle: {
      'pt-BR': 'Como a comunidade evolui força respeitando a recuperação.',
      'en-US': 'How the community builds strength while respecting recovery.',
    },
    posts: 259,
    category: 'strength',
  },
]

export const suggestedSearches: string[] = [
  '#primeiros10km',
  '#disciplinaconstruida',
  '#sonoprimeiro',
  '#respirar5min',
  '#forcasemdor',
]

export const recentSearches: string[] = [
  'lucas.corre',
  '#primeiros10km',
  'natação',
]
